import _ from "lodash";
import {
  keyArgsForPagination,
  keyArgsForACLGlobalControlParametersPagination,
  mergeForOrganizationFeedPagination,
  mergeForACLGlobalControlParametersPagination,
  mergeForPagination,
} from "./modules/utils";

const PlatformTypePolicy = {
  PlatformQuery: {
    fields: {
      organizationFeed: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPagination(args);
            return keys;
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForOrganizationFeedPagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
      lrtJobFeedQuery: {
        keyArgs: args => {
          if (args) {
            const keys = _.keys(_.omit(args, ["after"]));

            return keys;
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
      aclGlobalControlParameters: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForACLGlobalControlParametersPagination(args);
            return keys;
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForACLGlobalControlParametersPagination({
              existing,
              incoming,
              readField,
              fieldVariables: args,
            });
          }
          return incoming;
        },
      },
      importSubjectStandardsJobs: {
        keyArgs: args => {
          const input = _.get(args, "input");
          if (input) {
            return _.keys(_.omit(input, ["after"]));
          }
          return [];
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          const input = _.get(args, "input", {});
          return mergeForPagination({
            existing,
            incoming,
            readField,
            filters: input,
          });
        },
      },
    },
  },
};

export default PlatformTypePolicy;
